module.exports = __webpack_public_path__ + "fonts/baronsans-lightitalic-webfont.802faa67.woff";